<div class="timeline__container">
  <div class="timeline__item relative" [ngClass]="classes()"></div>
  <p class="timeline__label">{{label()}}</p>
</div>
